// initial state
const state = {
	isLoggedIn: false,
	isConfirmed: false,
	status: '',
	plan: {
		name: '',
		trialDays: 0
	},
	profile: {
		email: null
	}
};

// getters
const getters = {
	profile: state => state
};

// actions
const actions = {};

// mutations
const mutations = {
	'LOGIN_USER'(state, payload) {
		state.isLoggedIn = true;
		state.profile = {
			email: payload.email
		};
	},
	'LOGOUT_USER'(state) {
		state.isLoggedIn = false;
		state.isConfirmed = false;
		state.profile = {
			email: null
		};
		state.status = '';
		state.plan = {
			name: '',
			trialDays: 0
		};
	},
	'CONFIRM_USER'(state) {
		state.isConfirmed = true;
	},
	'UPDATE_SUB_INFO'(state, payload) {
		state.status = payload.status.toLowerCase();
		state.plan.name = payload.plan.name;
		state.plan.trialDays = payload.plan.trialDays;
	}
};
export default {
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./app/store/modules/user.js